// extracted by mini-css-extract-plugin
export default {"container":"container__Nezog","scrollable":"scrollable__cRTCb"};